<template>
  <div class="educational-material-box">
    <div>
      <portal to="educational-material-sidebar" class="position-relative">
        <div
          v-if="foldersLoading"
          class="position-absolute d-flex justify-content-center py-20 w-100"
        >
          <wtr-loader class="d-block" variant="primary" addText></wtr-loader>
        </div>
        <div :class="{ 'fetch-class': foldersLoading }">
          <folders
            v-if="folders"
            :selectedFolder="selectedFolder"
            :activeFolder="activeFolder"
            :foldersLoading="foldersLoading"
            :rootFolder="rootFolder"
            :folders="folders"
            :copiedFolder="copiedFolder"
            :disableActions="true"
            @selected="folderSelected"
            @cut-action="cutEducationalAction"
            @get-folders="getFolders()"
            @reset="resetEducationalFolders()"
            @temp-selected="selectedFolder = $event"
          ></folders>
        </div>
      </portal>
      <b-card no-body hide-footer>
        <div slot="header" class="fs-16 text-light" style="padding:2px 0px">
          <div class="d-flex justify-content-between">
            <span>
              <breadcrumbs v-if="typeof crumbs === 'object'" :items="crumbs" />
              <span v-else>{{ crumbs }}</span>
            </span>
          </div>
        </div>
        <b-card-body class="position-relative">
          <educational-material-box 
          :currentFolder="currentFolder" 
            :key="currentFolderKey"
            @folder-changed="handleFolderChange"
            @material-saved="handleMaterialSaved"
            ></educational-material-box>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// Mixins
import { EducationalMaterialMixin } from "../../../mixins/mixins";

// Components
import BreadcrumbsComponent from "../../../components/common/breadcrumbs.vue";
import EducationalFoldersComponent from "../components/folders.vue";
import EducationalMaterialBoxComponent from "../components/educational-material-box.vue";
import * as roleTypes from "../../../constants/constants-role";

export default {
  name: "MyEducationalMaterial",
  data() {
    return {
      ...roleTypes,
      isFoldersLoaded: false,
      listLoading: false,
      paramsUtil: {},
      materials: [],
      currentFolder: null,
      currentFolderKey: 0,
      allFolders: [],
    };
  },
  components: {
    "educational-material-box": EducationalMaterialBoxComponent,
    folders: EducationalFoldersComponent,
    breadcrumbs: BreadcrumbsComponent,
  },
  mixins: [EducationalMaterialMixin],
  computed: {
    ...mapGetters({
      sidebar: "getSidebar",
      crumbs: "getCrumbs",
    }),
    cardBodyStyles() {
      const height = this.$dashboardHeight - 60;
      return this.$getCardBodyStyle(height);
    },
    folderId() {
      return this.$pathParams.id || 0;
    },
  },
  mounted() {
    this.init();
  },
  updated() {
    
  },
  methods: {
    ...mapActions(["renderSidebarAction", "sidebarAction"]),
    init() {
      this.renderSidebarAction("educational-material-sidebar");
      this.sidebarAction({ show: true, full: true });
      this.$setHeaderAction(
        this.$t("educationalmaterial.myEducationalMaterial")
      );
      this.getFolders();
    },
    getFolders() {
      const options = {
        userId: localStorage.getItem("userId"),
      };
      this.getAllEducationalFolders(options, (activeFolder) => {
        this.folderSelected(activeFolder);
      });
    },
    folderSelected(node) {
      if (!node) return;
      console.log(node, "node");

      this.activeFolder = node;
      this.selectedFolder = node;
      this.$setHeaderAction(node.name);
      this.currentFolder = node;
      this.currentFolderKey += 1;
    },
    handleFolderChange() {
      console.log("Folder data was changed in child component");
    },
     handleMaterialSaved() {
      if (this.isPublishedFolder(this.currentFolder)) {
        const unpublishedFolder = this.findUnpublishedFolder(this.folders);
        if (unpublishedFolder) {
          console.log('Auto-switching to unpublished folder:', unpublishedFolder);
          this.folderSelected(unpublishedFolder);
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.card {
  position: initial !important;
}
</style>
